export default __webpack_public_path__ + "static/meshery-core-architecture-ada2489fcafbb125bde85de34ba3116e.webp";